import { PlatformHeader } from '../../../shared/platform/PlatformHeader';
import { MountainBackdrop } from '../../../shared/ui/MountainBackdrop';

/**
 * The Scenario Center header.
 *
 * The platform header is inherited, not rebuilt, and it stays on both pages — it is the global
 * navigation.
 *
 * The module title block is the LIBRARY's, not the detail page's. On the library it names the
 * module and says what the module is for. On the detail page the reader already knows where they
 * are; repeating a large module banner above a breadcrumb, a scene title and two tabs produced
 * three stacked headings for one page. The detail page therefore gets the platform header and
 * nothing else above its own breadcrumb.
 */
export function ScenarioCenterHeader({
  variant = 'library',
}: {
  readonly variant?: 'library' | 'detail';
}) {
  return (
    <header className="scc-header">
      <PlatformHeader activePage="scenario-center" brandPresentation="text" />
      {variant === 'library' && (
        <div className="p01-titlebar scc-titlebar">
          <MountainBackdrop />
          <h1>场景中心</h1>
          <p>从典型消防问题出发，了解需要掌握的信息、所需能力与参考依据。</p>
        </div>
      )}
    </header>
  );
}
